export class Cart { 
    public   viewName="Cart";
    public  lstCartList:any=[];
    public  PakageName:string="";
    public  PakageDays:number=0;
    public BranchId:number=0;
    
   
   }
   
   